import { useEffect, useRef, useState } from 'react';
import moment, { Moment } from 'moment';
import { useApiFetch } from './api/useApiFetch';
import PusherService from '../services/pusher';

export interface ITrackingMapMaster {
    master_id: number;
    name: string;
    geolocation: {
        latitude: number;
        longitude: number;
    };
    logisticianStatus?: {
        color: string;
        id: number;
        name: string;
        text_color: string | null;
    };
    specializes_in: string | null;
    commentary: string;
    free: boolean;
    batteryLvl: string | null;
}

export const useTrackingMapMasters = (channel: string) => {
    const { fetchData } = useApiFetch();
    const [masters, setMasters] = useState<ITrackingMapMaster[]>([]);
    const fetching = useRef(false);
    const lastFetchDate = useRef<Moment>();

    const socket = useRef<PusherService>();

    const getMasters = async () => {
        if (fetching.current) {
            return;
        }

        if (lastFetchDate.current) {
            const diff = moment.duration(moment().diff(lastFetchDate.current));
            if (diff.asMinutes() < 3) {
                return;
            }
        }

        fetching.current = true;
        const response = await fetchData<ITrackingMapMaster[]>('/tracking-map/masters', 'get', true);

        if (response.success && Array.isArray(response.data)) {
            setMasters(response.data);
        }

        lastFetchDate.current = moment();
        fetching.current = false;
    };

    const openSocket = () => {
        const conn = new PusherService();
        conn.registerMessageListener('master-geolocation-updated', getMasters);
        conn.open(channel);
        socket.current = conn;
    };

    useEffect(() => {
        getMasters();
        openSocket();
        return () => {
            socket.current?.close();
        };
    }, []);

    return {
        masters,
    };
};
